define('modules/wawi/product/controllers/tabs/PriceTabController',[], function () {
	'use strict';

	return ($parentScope, $scope, { ShopService, SessionValuesService, BASE_TEMPLATES_PATH, $rootScope }) => {
		$parentScope.formTabs.push({
			label: 'FIELDS.PRICE',
			template: BASE_TEMPLATES_PATH + '/wawi/product/form-prices.html',
		});

		$rootScope.$on('$translateChangeSuccess', function (e, { language }) {
			$scope.locale = language;
		});

		$scope.initProductPricesArray = (permitted, sortProductPrices) => {
			if (!$parentScope.entity || !permitted) {
				return;
			}

			if (!$parentScope.entity.prices || !$parentScope.entity.prices.length) {
				//TODO: hard coded group id. Where can I get the group id. Is the feature groups still existent?
				$parentScope.entity.prices = [{ fromAmount: 1, toAmount: -1, customerGroup: { id: 1 } }];
			} else {
				if (sortProductPrices) {
					$parentScope.entity.prices.sort(function (a, b) {
						return a.fromAmount - b.fromAmount;
					});
				}

				for (let price of $parentScope.entity.prices) {
					price.fromAmount = price.fromAmount ? price.fromAmount.toString() : '';
					price.toAmount = price.toAmount ? price.toAmount.toString() : '';
				}
			}
		};

		$scope.initPrices = function () {
			var shopId = SessionValuesService.getShop();

			var set = new Set();
			if ($parentScope.entity.prices == undefined) {
				$parentScope.entity.prices = [];
			}

			ShopService.findOne(shopId).then(function () {
				var shop = ShopService.getOne();
				$parentScope.availableData.customerGroupId = shop.defaultCustomerGroupId;
				/* if(!set.has($scope.customerGroupId)) {
					$scope.customerGroupId = list[0];
				}*/
			});

			$scope.initProductPricesArray();
		};

		$scope.removePricesWithNoSellingPrice = () => {
			if ($parentScope.entity.prices) {
				$parentScope.entity.prices = $parentScope.entity.prices.filter((productPrice) => {
					return productPrice.sellingPrice !== undefined && productPrice.sellingPrice !== null;
				});
			}
		};

		$scope.convertInfinityRanges = () => {
			if ($parentScope.entity.prices) {
				$parentScope.entity.prices.forEach((productPrice) => {
					if (isNaN(parseInt(productPrice.toAmount))) {
						productPrice.toAmount = -1;
					}
					if (isNaN(parseInt(productPrice.fromAmount))) {
						productPrice.fromAmount = -1;
					}
				});
			}
		};

		$parentScope.$on('afterInit', function () {
			if ($parentScope.entity.prices == undefined || $parentScope.entity.prices.length == 0) {
				//TODO: hard coded group id. Where can I get the group id. Is the feature groups still existent?
				$parentScope.entity.prices = [{ fromAmount: 1, toAmount: -1, customerGroup: { id: 1 } }];
			} else {
				for (let index in $parentScope.entity.prices) {
					$parentScope.entity.prices.sort(function (a, b) {
						return a.fromAmount - b.fromAmount;
					});
					$parentScope.entity.prices[index].fromAmount = $parentScope.entity.prices[
						index
					].fromAmount.toString();
					$parentScope.entity.prices[index].toAmount = $parentScope.entity.prices[index].toAmount.toString();
				}
			}
		});

		$scope.showAddButton = function (entity) {
			// Check if we got a variant. If not assume parent is used
			if (!entity || !entity.id) {
				entity = $parentScope.entity;
			}

			if (
				entity &&
				entity.prices.filter(function (value) {
					if (value.customerGroup.id === $parentScope.availableData.customerGroupId) {
						return true;
					} else {
						return false;
					}
				}).length === 0
			) {
				return true;
			}
			return false;
		};

		$scope.addPrice = function (currentHighestPrice, entity) {
			// Check if we got a variant. If not assume parent is used
			if (!entity || !entity.id) {
				entity = $parentScope.entity;
			}

			if (currentHighestPrice === undefined) {
				entity.prices.push({
					fromAmount: '1',
					toAmount: '-1',
					sellingPrice: 0,
					customerGroup: {
						id: $parentScope.availableData.customerGroupId,
					},
				});
				return;
			}
			if (typeof currentHighestPrice.toAmount == 'string'
				|| parseInt(currentHighestPrice.toAmount) >= parseInt(currentHighestPrice.fromAmount)
				|| currentHighestPrice.toAmount === -1) {
				// Determine new toAmount of previous highest
				if (entity.prices.length === 1) {
					currentHighestPrice.toAmount = 1;
				} else {
					// There should be more than 1 price at this point
					const previousToHighestPrice = entity.prices[entity.prices.length - 2];
					if (typeof previousToHighestPrice.toAmount == 'number') {
						currentHighestPrice.toAmount = parseInt(previousToHighestPrice.toAmount) + 1;
					} else {
						currentHighestPrice.toAmount = 1;
					}
				}

				var fromAmountNew = (parseInt(currentHighestPrice.toAmount) + 1).toString();
				entity.prices.push({
					fromAmount: fromAmountNew,
					toAmount: '-1',
					sellingPrice: currentHighestPrice.sellingPrice,
					pseudoPrice: currentHighestPrice.pseudoPrice,
					customerGroup: {
						id: $parentScope.availableData.customerGroupId,
					},
				});
				jQuery('.last-item input').css('border-color', '');
			} else {
				jQuery('.last-item input').css('border-color', 'red');
			}
			$scope.checkRange();
		};

		$scope.removePrice = function (price, entity) {
			// Check if we got a variant. If not assume parent is used
			if (!entity || !entity.id) {
				entity = $parentScope.entity;
			}

			const priceIndex = $parentScope.entity.prices.indexOf(price);
			if (priceIndex === -1) {
				// Should not happen
				return;
			} else {
				entity.prices.splice(priceIndex, 1);
			}

			const customerGroupPrices = entity.prices.filter((productPrice) => {
				return productPrice.customerGroup.id === price.customerGroup.id;
			});

			const customerGroupLastPrice = customerGroupPrices[customerGroupPrices.length - 1];

			if (customerGroupLastPrice !== undefined) {
				customerGroupLastPrice.toAmount = -1;
			}
		};

		$scope.checkRange = function () {

			return true;
		};

		/**
		 * Is used in ProctBundleFormController too
		 */
		$scope.isAtLeastOneSellingPricePresent = (product) => {
			const productPrice = product.prices.find(
				(productPrice) => productPrice.sellingPrice !== null && productPrice.sellingPrice !== undefined
			);

			return productPrice !== undefined;
		};

		$scope.setPriceDefaultValues = () => {
			$parentScope.entity.showPriceSearch = true;
			$parentScope.entity.showPriceCatalog = true;
			$parentScope.entity.showPriceDetail = true;
		};
	};
});

